<div class="w-full flex flex-col items-center bg-blue2 text-white py-8" *transloco="let t; read: 'home.frequently_asked'">
  <div class="w-11/12 md:w-11/12 lg:w-2/4 flex flex-col items-center space-y-6">
    <psc-section-title class=" text-center" [title]="t('title')" [color]="'text-white'"></psc-section-title>

    <div *ngFor="let faq of faqs; let i = index" class="w-full">
      <div class="p-3 border border-gray-300 rounded-lg shadow-lg bg-white text-blue1">
        <div class="flex justify-between cursor-pointer hover:text-blue-500 transition-colors duration-300"
             (click)="toggleAnswer(i)">
          <h5 class="w-full">
            {{ t(faq.title) }}
          </h5>

          <mat-icon>
            {{ faq.showAnswer ? 'expand_less' : 'expand_more' }}
          </mat-icon>
        </div>

        <p *ngIf="faq.showAnswer" @inOutAnimation
           class="mt-4 mb-2 text-gray-700 transition-opacity duration-300 ease-in-out">
          {{ t(faq.answer)}}
        </p>
      </div>
    </div>
  </div>
</div>
